<ng-container *transloco="let t" anihisCloseOnEsc (escPressed)="closeDialog()">
  @if (data) {
    <h2 mat-dialog-title>
      {{ data.name }}
      <mat-icon
        [ngClass]="data?.gender === 'Male' ? 'male-icon' : 'female-icon'"
      ></mat-icon>
    </h2>
    <div class="content">
      <mat-list>
        <mat-list-item>
          <p>{{ t('Species') }}</p>
          @if (data?.species?.name) {
            <b>{{ t(data.species?.name ?? '') }}</b>
          } @else {
            <div
              class="flex items-center justify-center"
              style="width: 24px; height: 24px"
            >
              <span class="no-data">-</span>
            </div>
          }
        </mat-list-item>
        <mat-divider></mat-divider>

        <mat-list-item>
          <p>{{ t('Breed') }}</p>
          @if (data?.breed?.name) {
            <b>{{ t(data.breed?.name ?? '') }}</b>
          } @else {
            <div
              class="flex items-center justify-center"
              style="width: 24px; height: 24px"
            >
              <span class="no-data">-</span>
            </div>
          }
        </mat-list-item>
        <mat-divider></mat-divider>

        <mat-list-item>
          <p>{{ t('Color') }}</p>
          @if (colorHexes.length > 0) {
            <div class="flex gap-2">
              @for (color of colorHexes; track color) {
                <div
                  class="w-6 h-6 rounded-full border border-gray-300"
                  [style.background-color]="color"
                  title="{{ color }}"
                ></div>
              }
            </div>
          } @else {
            <div
              class="flex items-center justify-center"
              style="width: 24px; height: 24px"
            >
              <span class="no-data">-</span>
            </div>
          }
        </mat-list-item>

        <mat-divider></mat-divider>

        <mat-list-item>
          <p>{{ t('Date of birth') }}</p>
          @if (data?.birthDateTime) {
            <b>{{
              data.birthDateTime | parseUtcToLocal | localDate
            }}</b>
          } @else if (data?.birthDateText) {
            <b>{{ data.birthDateText }}</b>
          } @else {
            <div
              class="flex items-center justify-center"
              style="width: 24px; height: 24px"
            >
              <span class="no-data">-</span>
            </div>
          }
        </mat-list-item>
        <mat-divider></mat-divider>

        <mat-list-item>
          <p>{{ t('Card') }}</p>
          @if (data?.cartonNumber) {
            <b>{{ data.cartonNumber }}</b>
          } @else {
            <div
              class="flex items-center justify-center"
              style="width: 24px; height: 24px"
            >
              <span class="no-data">-</span>
            </div>
          }
        </mat-list-item>
        <mat-divider></mat-divider>

        <mat-list-item>
          <p>{{ t('Owner') }}</p>
          @if (data?.owner?.firstName && data?.owner?.lastName) {
            <b>{{ data.owner.firstName + ' ' + data.owner.lastName }}</b>
          } @else {
            <div
              class="flex items-center justify-center"
              style="width: 24px; height: 24px"
            >
              <span class="no-data">-</span>
            </div>
          }
        </mat-list-item>
        <mat-divider></mat-divider>

        <mat-list-item>
          <p>{{ t('Marking Date') }}</p>
          @if (data?.markingDateTimeUtc) {
            <b>{{
              data.markingDateTimeUtc | parseUtcToLocal | localDate
            }}</b>
          } @else {
            <div
              class="flex items-center justify-center"
              style="width: 24px; height: 24px"
            >
              <span class="no-data">-</span>
            </div>
          }
        </mat-list-item>
        <mat-divider></mat-divider>

        <mat-list-item>
          <p>{{ t('Microchip') }}</p>
          @if (
            data?.microchip &&
            data.microchip !== 'null' &&
            data.microchip !== 'NULL'
          ) {
            <b>{{ data.microchip }}</b>
          } @else {
            <div
              class="flex items-center justify-center"
              style="width: 24px; height: 24px"
            >
              <span class="no-data">-</span>
            </div>
          }
        </mat-list-item>
        <mat-divider></mat-divider>

        <mat-list-item>
          <p>{{ t('Pedigree') }}</p>
          @if (
            data?.pedigree &&
            data.pedigree !== 'null' &&
            data.pedigree !== 'NULL'
          ) {
            <b>{{ data.pedigree }}</b>
          } @else {
            <div
              class="flex items-center justify-center"
              style="width: 24px; height: 24px"
            >
              <span class="no-data">-</span>
            </div>
          }
        </mat-list-item>
        <mat-divider></mat-divider>

        <mat-list-item>
          <p>{{ t('Passport Date') }}</p>
          @if (data?.passportDateTime) {
            <b>{{
              data.passportDateTime | parseUtcToLocal | localDate
            }}</b>
          } @else {
            <div
              class="flex items-center justify-center"
              style="width: 24px; height: 24px"
            >
              <span class="no-data">-</span>
            </div>
          }
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item>
          <p>{{ t('Passport Number') }}</p>
          @if (data?.passportNumber) {
            <b>{{ data.passportNumber }}</b>
          } @else {
            <div
              class="flex items-center justify-center"
              style="width: 24px; height: 24px"
            >
              <span class="no-data">-</span>
            </div>
          }
        </mat-list-item>
        @if (data?.sterilized) {
          <mat-divider></mat-divider>

          <mat-list-item>
            <p>{{ t('Sterilized') }}</p>
            <b style="display: flex; align-items: center; gap: 8px">
              {{ t('Sterilized') }}
              <mat-icon class="sterilized-icon cursor"></mat-icon>
              |
              {{
                data?.sterilizedDateTimeUtc
                  | parseUtcToLocal
                  | localDate
              }}
            </b>
          </mat-list-item>
        }
        <mat-divider></mat-divider>

        <mat-list-item>
          <p>{{ t('Warning') }}</p>
          @if (
            data?.warning && data.warning !== 'null' && data.warning !== 'NULL'
          ) {
            <b>{{ data.warning }}</b>
          } @else {
            <div
              class="flex items-center justify-center"
              style="width: 24px; height: 24px"
            >
              <span class="no-data">-</span>
            </div>
          }
        </mat-list-item>
      </mat-list>
    </div>

    <mat-dialog-actions align="end">
      <button mat-stroked-button (click)="closeDialog()" class="secondary-btn">
        {{ t('Close') }}
      </button>
    </mat-dialog-actions>
  } @else {
    <div
      class="loading-container"
      style="
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 200px;
      "
    >
      <mat-progress-spinner
        diameter="18"
        mode="indeterminate"
        strokeWidth="3"
      ></mat-progress-spinner>
    </div>
  }
</ng-container>
